import React from 'react';

const rtl = document.getElementsByTagName('html')[0].getAttribute('dir');

const withDirection = Component =>
  class extends React.Component {
    render() {
      return <Component {...this.props} data-rtl={rtl} />;
    }
  };

export default withDirection;
export { rtl };



// WEBPACK FOOTER //
// ./src/components/ui-ant/misc/theme/withDirection.js